import { render, staticRenderFns } from "./KnowledgeBaseManagementModal.vue?vue&type=template&id=1957b97a&scoped=true"
import script from "./KnowledgeBaseManagementModal.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseManagementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1957b97a",
  null
  
)

export default component.exports